// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Md5$LiteracyplanetClientLibsActivity from "./Md5.res.mjs";

var basicResponseSchema = S.object(function (s) {
      return {
              id: s.f("id", S.string),
              name: s.f("name", S.string),
              questionIndex: s.f("questionIndex", S.$$int),
              answers: s.f("answers", S.string),
              correct: s.f("correct", S.bool)
            };
    });

var batmanResponseSchema = S.object(function (s) {
      return {
              answer: s.f("answer", S.string),
              questionIndex: s.f("questionIndex", S.$$int),
              correct: s.f("correct", S.bool)
            };
    });

var schema = S.union([
      S.object(function (s) {
            s.tag("responseType", "BasicResponse");
            return {
                    TAG: "BasicResponse",
                    _0: {
                      responses: s.f("responses", S.array(basicResponseSchema))
                    }
                  };
          }),
      S.object(function (s) {
            s.tag("responseType", "BatmanResponse");
            return {
                    TAG: "BatmanResponse",
                    _0: {
                      responses: s.f("responses", S.array(batmanResponseSchema))
                    }
                  };
          }),
      S.object(function (param) {
            return "NotSet";
          })
    ]);

function decode(__x) {
  return S.parseJsonStringOrThrow(__x, schema);
}

function encode(__x) {
  return S.reverseConvertToJsonStringOrThrow(__x, schema, undefined);
}

function decodeIfMdFived(persistedState, md5) {
  var match = Md5$LiteracyplanetClientLibsActivity.get(md5);
  if (match !== undefined && persistedState !== undefined) {
    return S.parseJsonStringOrThrow(persistedState, schema);
  } else {
    return "NotSet";
  }
}

var responseStateData = {
  contents: "NotSet"
};

function initResponses(stringData, md5) {
  responseStateData.contents = decodeIfMdFived(stringData, md5);
}

function stringifyResponses(param) {
  var d;
  try {
    d = encode(responseStateData.contents);
  }
  catch (_e){
    return ;
  }
  return d;
}

function calcPercent(numerator, denominator) {
  return Math.ceil(numerator / denominator * 100.00) | 0;
}

function calculateAccuracy(param) {
  var match = responseStateData.contents;
  if (typeof match !== "object") {
    return 0;
  }
  if (match.TAG === "BasicResponse") {
    var responses = match._0.responses;
    var correct = Belt_Array.reduce(responses, 0, (function (acc, param) {
            return acc + (
                    param.correct ? 1 : 0
                  ) | 0;
          }));
    return calcPercent(correct, responses.length);
  }
  var responses$1 = match._0.responses;
  var correct$1 = Belt_Array.reduce(responses$1, 0, (function (acc, param) {
          return acc + (
                  param.correct ? 1 : 0
                ) | 0;
        }));
  return calcPercent(correct$1, responses$1.length);
}

function collectResponses(t) {
  var tmp;
  if (typeof t !== "object" || t.TAG !== "Orig") {
    tmp = responseStateData.contents;
  } else {
    var match = t._0;
    var r_id = match.id;
    var r_name = match.name;
    var r_questionIndex = match.questionIndex;
    var r_answers = match.answers;
    var r_correct = match.correct;
    var r = {
      id: r_id,
      name: r_name,
      questionIndex: r_questionIndex,
      answers: r_answers,
      correct: r_correct
    };
    var match$1 = responseStateData.contents;
    tmp = typeof match$1 !== "object" ? ({
          TAG: "BasicResponse",
          _0: {
            responses: [r]
          }
        }) : (
        match$1.TAG === "BasicResponse" ? ({
              TAG: "BasicResponse",
              _0: {
                responses: Belt_Array.concat(match$1._0.responses, [r])
              }
            }) : responseStateData.contents
      );
  }
  responseStateData.contents = tmp;
  return stringifyResponses();
}

function collectBatchResponses(responses) {
  var tmp;
  tmp = typeof responses !== "object" ? responseStateData.contents : ({
        TAG: "BatmanResponse",
        _0: {
          responses: Belt_Array.map(responses._0, (function (param) {
                  return {
                          answer: param.answer,
                          questionIndex: param.questionIndex,
                          correct: param.correct
                        };
                }))
        }
      });
  responseStateData.contents = tmp;
  return stringifyResponses();
}

function use(persistedState, md5) {
  React.useEffect((function () {
          initResponses(persistedState, md5);
          return (function () {
                    responseStateData.contents = "NotSet";
                  });
        }), []);
  return {
          collectResponses: collectResponses,
          collectBatchResponses: collectBatchResponses,
          stringifyResponses: stringifyResponses,
          calculateAccuracy: calculateAccuracy
        };
}

export {
  use ,
  decodeIfMdFived ,
  decode ,
}
/* basicResponseSchema Not a pure module */
